import theme_icons from '../../icons.js';
import { MediaUploaderGeneric } from '../../components/image-picker-generic.js';
import womanVolunteerIcon from './woman-volunteer-icon.svg';
import defaultImage from './map-desaturated-resized-compressed.png';

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { useState } = wp.element;
const { InspectorControls, MediaUpload, ColorPalette, RichText } = wp.blockEditor;
const { PanelBody, Button, TextControl } = wp.components;

 const meetcoordinator = {
	title: 'Meet Your Coordinator',
	icon: theme_icons.greenheart,
    category: 'greenheart',
    supports: {
        align: ['wide', 'full'],
    },
    //attributes
    attributes: {
        title: {
          type: 'string',
          default: '',
        },
        subtitle: {
          type: 'string',
          default: '',
        },
        profileName: {
          type: 'string',
          default: '',
        },
        textColor: {
            type: 'string',
            default: '',
        },
        backgroundColor: {
          type: 'string',
          default: 'green',
        },
        backgroundImage: {
          type: 'object',
          default: {},
        },
        profileImage: {
          type: 'object',
          default: {},
        },
    },
    
    edit({ attributes, setAttributes }) {
        const { title, subtitle, profileName, backgroundColor, textColor, backgroundImage, profileImage } = attributes;
    
        const onColorChange = (newColor) => {
          setAttributes({ backgroundColor: newColor });
        };
    
        const onTitleChange = (newTitle) => {
          setAttributes({ title: newTitle });
        };
    
        const onSubtitleChange = (newSubtitle) => {
          setAttributes({ subtitle: newSubtitle });
        };
    
        const onProfileNameChange = (newProfileName) => {
          setAttributes({ profileName: newProfileName });
        };
    
        const onBackgroundImageChange = (newImage) => {
          setAttributes({ backgroundImage: newImage });
        };
    
        const onProfileImageChange = (newImage) => {
          setAttributes({ profileImage: newImage });
        };
    
        return (
          <div className="rbt-meetcoordinatorblock">
            <InspectorControls>
              <PanelBody title="Background Settings">
                <p><strong>Background Color:</strong></p>
                <ColorPalette
                  value={backgroundColor}
                  onChange={onColorChange}
                />

                <p><strong>Background Color:</strong></p>
                <ColorPalette
                  value={textColor}
                  onChange={(value) => setAttributes({ textColor: value })}
                />

              </PanelBody>
              <PanelBody title="Profile Settings">
                <p><strong>Profile Image:</strong></p>
                <MediaUploaderGeneric
                  photo={profileImage}
                  updateImage={onProfileImageChange}
                />
              </PanelBody>
            </InspectorControls>
    
            <div className="sectionwrap" style={{ backgroundColor }}>
                <div className="bgImgWrap">
                    {backgroundImage.url ? (
                        <div className="background-image" style={{ backgroundImage: `url(${backgroundImage.url})` }} >
                        </div>
                    ) : (
                        <div className="background-image default" style={{ backgroundImage:`url(${defaultImage})`}}>
                        </div>
                    )}
                    <div class="gradient-overlay"   
                        style={{ backgroundImage: `linear-gradient(to right, transparent 0%, ${backgroundColor} 60%, ${backgroundColor} 100%)`,
                        }}>

                    </div>
                </div>
              <div className="bgImageArea">
                <p><strong>Background Image:</strong></p>
                    <MediaUploaderGeneric
                    photo={backgroundImage}
                    updateImage={onBackgroundImageChange}
                    />
              </div>
              <div className="textArea" style={{marginTop:"40px", display:"flex", flexDirection:"column", alignItems:"center"}}>
                <RichText
                    tagName="h2"
                    className="block-title"
                    value={title}
                    onChange={onTitleChange}
                    placeholder="Enter block title..."
                    style={{color: textColor}}
                />
                <RichText
                    tagName="h4"
                    className="block-subtitle"
                    value={subtitle}
                    onChange={onSubtitleChange}
                    placeholder="Enter subtitle..."
                    style={{color: textColor}}
                />
                <div className="profile-area">
                    <div className="profile-image-wrap">
                        <MediaUploaderGeneric
                        photo={profileImage}
                        updateImage={onProfileImageChange}
                        />
                        {console.log(profileImage)}
                        {
                            profileImage.mediaUrl ? (<></>) : (<img className="placeholder-image" src={womanVolunteerIcon} alt="Placeholder" />)
                        }
                    </div>
                    <TextControl
                    label="Profile Name"
                    value={profileName}
                    onChange={onProfileNameChange}
                    placeholder="Enter profile name..."
                    />
                </div>
              </div>
            </div>
          </div>
        );
    },
    
    save({ attributes }) {
        const { title, subtitle, profileName, backgroundColor, textColor, backgroundImage, profileImage } = attributes;
        const srcset = (profileImage) => {
            if(!profileImage.mediaSizes) {
                return '';
            } else {
                Object.values(profileImage.mediaSizes)
                .map(size => `${size.url} ${size.width}w`)
                .join(', ');
            }
        }
        return (
          <section className="rbt-meetcoordinatorblock" style={{ backgroundColor }} >
            <div className="sectionwrap">
                <div className="bgImgWrap" >
                    <div className="background-image" 
                        style={{ backgroundImage: backgroundImage?.url ? `url(${backgroundImage.url})` : `url(${defaultImage})` }} >
                        </div>
                    <div class="gradient-overlay"   
                        style={{ backgroundImage: `linear-gradient(to right, transparent 0%, ${backgroundColor} 60%, ${backgroundColor} 100%)`,
                    }}> </div>
                </div>
                <div className="block-content">
                    {title && (
                        <RichText.Content
                        tagName="h2"
                        className="block-title"
                        value={title}
                        style = {{color: textColor}}
                        />
                    )}
                    {subtitle && (
                        <RichText.Content
                        tagName="p"
                        className="block-subtitle"
                        value={subtitle}
                        style = {{color: textColor}}
                        />
                    )}
                    {profileName && profileImage.mediaUrl && (
                        <div className="profile-area">
                            <img
                            className="profile-img"
                            src={profileImage.mediaUrl}
                            alt={profileName}
                            srcSet={srcset(profileImage)}
                            />
                            <p className="profile-name" style={{color: textColor}}>{profileName}</p>
                        </div>
                    )}
                </div>
            </div>
          </section>
        );
      },
    
};
registerBlockType('rbt/meetcoordinator', meetcoordinator);
export default meetcoordinator;
